module.exports = (homeworkId) => {
  return [
    { name: 'Task', prop: 'task', type: 'text' },
    { name: 'Position', prop: 'position', type: 'number' },
    {
      name: 'Day',
      prop: 'day_id',
      type: 'autocomplete',
      references: 'admin/days',
      referenceProp: 'date',
      query: {
        filters: {
          homework_id: homeworkId || ''
        }
      }
    }
  ]
}
